<template>
    <RoundedContainer>
        <h5 class="title is-5 pt-4">Open post from S3</h5>
        <div class="columns">
            <div class="column is-12">
                <button @click="getPosts"
                    class="button has-text-centered is-primary mb-2 slightly-rounded"
                >
                    <span class= "icon is-small"><i class="fa-solid fa-folder-open"></i></span>
                    <span>Open</span>
                </button>
            </div>
        </div>
    </RoundedContainer>

    <LoadingSpinner v-if="loading" class="m-3"/>
    <div v-else v-for="post in posts">
        <PostWrapper 
            :post="post"
            @open-post-clicked="onOpenPostFromS3(post)"
            @delete-post-clicked="deletePost(post)"
        />
    </div> 

    <!-- <RoundedContainer>
        <h5 class="title is-5 pt-4">Open post from this device</h5>
        <div class="columns">
            <div class="column is-12">
                <button @click=""
                    class="button has-text-centered is-grey mb-2 slightly-rounded"
                >
                    <span class= "icon is-small"><i class="fa-solid fa-folder-open"></i></span>
                    <span>Open</span>
                </button>
            </div>
        </div>
    </RoundedContainer> -->
</template>  

<script>
import PostWrapper from '@/widgets/PostWrapper.vue'
import LoadingSpinner from '@/widgets/LoadingSpinner.vue'
import RoundedContainer from '@/widgets/RoundedContainer.vue'
import { deleteFile, getS3Files, getS3FileBody, getS3FileTags } from '@/js/uploader'
import { deleteBeforeFinalSlash } from "@/js/general.js"
import YAML from 'yaml'

async function setPostInfo(post) {
    // set the post ID
    post.postId = post.filename
    // get the post's content from s3
    post.content = await getPostContent(post)
    // set the front matter
    post.frontMatter = calculateFrontMatter(post.content)
    // set the post body (the main text)
    post.body = calculatePostBody(post.content)

    return post
}

async function getPostContent(postObject) {
    return await getS3FileBody(
        process.env.VUE_APP_BUCKET_BLOG,
        postObject.Key
    )
}

function calculateFrontMatter(postContent) {
    // get the front matter
    let data = postContent.split('---')[1]
    // decode the YAML
    data = YAML.parse(data)

    return data
}

function calculatePostBody(postContent) {
     let postBody = postContent.split('---')[2]
     // remove '\n\n' from the start of the string 
     postBody = postBody.replace(/^(\n){2}/, '')
     return postBody
}

export default {
    name: 'OpenButtons',
    emits: ['postOpened'],
    components: { PostWrapper, LoadingSpinner, RoundedContainer },
    data() {
        return {
            posts: [],
            loading: false
        }
    },
    methods: {
        async getPosts() {
            console.log('getting posts')
            this.loading = true
            this.posts = await getS3Files('posts')
            this.loading = false
            this.posts = deleteBeforeFinalSlash(this.posts)
            console.log('posts --->', this.posts)
        },
        async deletePost(object) {
            await deleteFile(process.env.VUE_APP_BUCKET_BLOG, object.Key)
            this.getPosts()
        },
        async onOpenPostFromS3(post) {
            this.loading = true
            // build the post
            post = await setPostInfo(post)
            // emit the post
            this.$emit('postOpened', { post })
            this.loading = false
        }
    }
}
</script>

